import { FilterParams } from "src/library/utils";
import useAxios, { IApiResponse } from "src/core/shared/hooks/useAxios";
import { IDeliveryRoute } from "src/core/drops/api/drops.api";

type DeliveryRoutesApi = "GET_DELIVERY_ROUTES" | "UPDATE_DELIVERY_ROUTE" | "DELETE_DELIVERY_ROUTE" | "CREATE_DELIVERY_ROUTE" | "GET_DELIVERY_ROUTE";

type GetDeliveryRoutesParams = { filters: FilterParams<IDeliveryRoute> };
export type UpdateDeliveryRoute = { id: number } & Partial<IDeliveryRoute>;
export const deliveryRoutesApi = <R, P = any>(name: DeliveryRoutesApi): [IApiResponse<R, any>, <C = P>(P: C) => void] => {
  switch (name) {
    case "GET_DELIVERY_ROUTE":
      return useAxios<R, GetDeliveryRoutesParams>(
        (deliveryRouteId: number) => ({
          url: `${process.env.REACT_APP_API_URL}/core/delivery-routes/${deliveryRouteId}`,
          method: "GET"
        }),
        name
      );

    case "GET_DELIVERY_ROUTES":
      return useAxios<R, GetDeliveryRoutesParams>(
        (params: GetDeliveryRoutesParams) => ({
          url: `${process.env.REACT_APP_API_URL}/core/delivery-routes`,
          method: "GET",
          params: { filters: params }
        }),
        name
      );

    case "UPDATE_DELIVERY_ROUTE":
      return useAxios<R, GetDeliveryRoutesParams>(
        (data: UpdateDeliveryRoute) => ({
          url: `${process.env.REACT_APP_API_URL}/core/delivery-routes`,
          method: "PATCH",
          data
        }),
        name
      );

    case "CREATE_DELIVERY_ROUTE":
      return useAxios<R, GetDeliveryRoutesParams>(
        (data: Omit<IDeliveryRoute, "id">) => ({
          url: `${process.env.REACT_APP_API_URL}/core/delivery-routes`,
          method: "POST",
          data
        }),
        name
      );

    case "DELETE_DELIVERY_ROUTE":
      return useAxios<R, GetDeliveryRoutesParams>(
        (deliveryRouteId: number) => ({
          url: `${process.env.REACT_APP_API_URL}/core/delivery-routes/${deliveryRouteId}`,
          method: "DELETE"
        }),
        name
      );

    default:
      throw new Error("errorsApi requires a name parameter");
  }
};
